import Vue from 'vue'
import Router from 'vue-router'
import Clarity from '@microsoft/clarity'

import { getLocalDataMiddleware, getEndpointConfigMiddleware, checkAccessMiddleware, setPageTitleMiddleware, closeSidebarMobileMiddleware, getPermissionByUser } from './middlewares'
import { routes } from './routes'

Vue.use(Router)

const router = new Router({
  linkActiveClass: 'mm-active',
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
router.beforeEach(getLocalDataMiddleware)
router.beforeEach(getEndpointConfigMiddleware)
router.beforeEach(checkAccessMiddleware)
router.beforeEach(setPageTitleMiddleware)
router.beforeEach(closeSidebarMobileMiddleware)
router.beforeEach(getPermissionByUser)
router.beforeEach((to, _from, next) => {
  const currentUser = JSON.parse(localStorage.getItem('userData') || '{}');
  const token = localStorage.getItem('token') || '';
  if (currentUser?.username && token) {
    Clarity.identify(currentUser.username, token.slice(-9), to.fullPath, to.name);
  }
  next()
})
export default router
